import React from "react";
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import CameraFrontRoundedIcon from '@material-ui/icons/CameraFrontRounded';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import GetAppIcon from '@material-ui/icons/GetApp';
import RefreshIcon from '@material-ui/icons/Refresh';
import SaveReportIcon from '@material-ui/icons/Description';
import ExportExcel from '@material-ui/icons/SaveAlt';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import FilterListIcon from '@material-ui/icons/FilterList';
import DirectionsTwoToneIcon from '@material-ui/icons/DirectionsTwoTone';
import DraftsIcon from '@material-ui/icons/Drafts';
import MarkunreadIcon from '@material-ui/icons/Markunread';
import CancelIcon from '@material-ui/icons/Cancel';
import HistoryIcon from '@material-ui/icons/History';
import DoneAll from '@material-ui/icons/DoneAll';
import CheckBox from '@material-ui/icons/CheckBox';
import FilterList from '@material-ui/icons/FilterList';
import VisibilityIcon from '@material-ui/icons/Visibility';
import QuickView from "./quickview";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { getEnvVariable } from "../../../modules/environmentalList";
import HowToVoteIcon from '@material-ui/icons/HowToVote';
import DateRangeIcon from '@material-ui/icons/DateRange';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import LaptopIcon from '@material-ui/icons/Laptop'; import LaptopTwoToneIcon from '@material-ui/icons/LaptopTwoTone';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { Typography } from "@material-ui/core";

const fieldTypes = {
  edit: { icon: EditIcon, title: 'Edit' },
  add: { icon: AddIcon, title: 'Add' },
  save: { icon: SaveIcon, title: 'Save' },
  close: { icon: CloseIcon, title: 'Close' },
  back: { icon: ChevronLeftIcon, title: 'Back' },
  duplicate: { icon: FileCopyIcon, title: 'Duplicate' },
  download: { icon: GetAppIcon, title: 'Download' },
  refresh: { icon: RefreshIcon, title: 'Refresh' },
  reports: { icon: SaveReportIcon, title: 'Reports' },
  excel: { icon: ExportExcel, title: 'Export' },
  clear: { icon: ClearAllIcon, title: 'Clear' },
  markread: { icon: DraftsIcon, title: 'Read' },
  markunread: { icon: MarkunreadIcon, title: 'Unread' },
  cancel: { icon: CancelIcon, title: 'Dismissed' },
  history: { icon: HistoryIcon, title: 'History' },
  check_box: { icon: CheckBox, title: 'Select' },
  doneall: { icon: DoneAll, title: 'Download' },
  Filter: { icon: FilterListIcon, title: 'Filter' },
  quickview: { icon: QuickView, title: 'Quick View' },
  delete: { icon: DeleteForeverIcon, title: 'Delete' },
  load: { icon: CameraFrontRoundedIcon, title: 'Load' },
  route: { icon: DirectionsTwoToneIcon, title: 'Route' },
  clearDate: { icon: EventBusyIcon, title: 'Clear Date' },
  howtovote: { icon: HowToVoteIcon, title: 'How to Vote' },
  asofdate: { icon: DateRangeIcon, title: 'As of Date' },
  accessaccount: { icon: LaptopTwoToneIcon, title: 'Access Account' },
  contactsupport: { icon: AccountCircleIcon, title: 'Contact Support' }
};
const validate = (name, value, condition) => {
  switch (condition) {
    case 'not in':
      if (!value.includes(name))
        return true
      else return false
    default:
      return false
  }

}

export default function Icons(props) {

  const { icon, type, title, color, name, hidevalue, sharedProps, hideon, isLocalStorage, condition, IsBuildMGR, IsExternal = false, ...otherProps } = props
  const EachComp = fieldTypes[icon]?.icon;
  const fabTitle = fieldTypes[icon]?.title;

  if (sharedProps && hidevalue && (sharedProps[hideon] === hidevalue)) {
    return null
  }
  else if (isLocalStorage && isLocalStorage.value === localStorage.getItem(isLocalStorage.name)) {
    return null
  }
  else if (condition && validate(sharedProps[hideon], hidevalue, condition)) {
    return null
  }
  else if (IsBuildMGR && getEnvVariable('BuildScopeMGR') === true) {
    return null
  }
  else if (IsExternal && getEnvVariable('AccessPortal') === 'E') {
    return null
  }
  else if (otherProps.onClick === "hidedisplay")
    return null;
  else {
    if (name === 'quickview') {
      return <i className={name} {...otherProps}>&nbsp;<IconButton size="small" title={title ? title : ''} color={color ? color : "inherit"}> <EachComp {...props} />
      </IconButton></i>
    } else {
      return <i className={name + " col px-1"} {...otherProps}>
        <IconButton
          size="small"
          title={title ? title : ''}
          color={color ? (otherProps.disabled ? 'default' : color) : "inherit"}
          style={{ padding: '2px' }}
          disabled={otherProps.disabled ? otherProps.disabled : false}
        >
          <EachComp fontSize='small' color='secondary' />
          {title && <Typography variant="caption" color="primary" style={{ px: '4px' }}>{fabTitle}</Typography>}
        </IconButton>
      </i>
    }

  }

}